import Api from "../common/Api";
import {Form, message, Modal, Select, Spin} from "antd";
import React, {useEffect, useState} from "react";

const optionsAdaptor = (groups: string[]) => {
    return groups.map((group) => ({
        value: group,
        label: group
    }))
}

interface Props {
    username?: string;
    isVisible: boolean
    setVisible: React.Dispatch<React.SetStateAction<boolean>>
    setLocalRefresh: React.Dispatch<React.SetStateAction<number>>
}

const ModalGroup = (props: Props) => {
    const [groups, setGroups] = useState([]);
    const [group, setGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);

    useEffect(() => {
        (async () => {
            const {data} = await Api.groupsManagement.getGroups()
            setGroups(data)
            setLoading(false)
        })();
    }, [])


    return (
        <Modal
            title={`Add user ${props.username} to group`}
            visible={props.isVisible}
            okText={'Add to group'}
            cancelText={'Cancel'}
            onCancel={() => props.setVisible(!props.isVisible)}
            confirmLoading={buttonLoading}
            okButtonProps={{
                disabled: !group
            }}
            onOk={async () => {
                try {
                    setButtonLoading(true);
                    await Api.usersManagement.addUserToGroup(props.username!, group!)
                    setGroup(null)
                    props.setLocalRefresh(1000);
                    props.setVisible(!props.isVisible)
                    message.success("User added to group");
                } catch (e) {
                    message.error("Error while adding user to group");
                    throw (e)
                } finally {
                    setButtonLoading(false);
                }

            }}
        >
            <Form.Item>
                <Select style={{marginTop: "2em", width: '100% !important'}} showSearch
                        onChange={setGroup}
                        loading={loading}
                        value={group}
                        options={optionsAdaptor(groups)}
                        placeholder={"Select..."}
                        notFoundContent={optionsAdaptor(groups) ? <Spin size="small"/> : null}
                        filterOption={(input, option) => (option!.label as unknown as string).includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                                .toLowerCase()
                                .localeCompare((optionB!.value as unknown as string).toLowerCase())}
                />
            </Form.Item>
        </Modal>

    )
}

export default ModalGroup;
